{
	"language": {
		"aria": "Sprache ändern"
	},
	"placeholder": {
		"title": "Ihr Kandidatenbereich ist unterwegs",
		"body": "Hier gibt es noch nichts zu sehen. Sobald es bereit ist, senden wir Ihnen per E-Mail einen Link."
	},
	"not_found": {
		"title": "Seite nicht gefunden",
		"body": "Überprüfen Sie den von Ihnen aufgerufenen Link oder verwenden Sie den Link aus Ihrer E-Mail."
	},
	"error_boundary": {
		"reload": "Seite neu laden"
	},
	"login": {
		"loading": "Wird geladen…",
		"title": "Melden Sie sich in Ihrem Kandidatenbereich an",
		"intro": "Geben Sie Ihre E-Mail-Adresse ein, um Ihre Bewerbungen zu sehen.",
		"email_label": "E-Mail-Adresse",
		"email_placeholder": "sie@beispiel.de",
		"submit": "Anmelden",
		"sending": "Wird gesendet…",
		"sent": {
			"title": "Überprüfen Sie Ihre E-Mails",
			"body": "Wenn {{email}} zu einer Bewerbung passt, ist ein Anmeldelink zu Ihnen unterwegs.",
			"retry": "Nicht erhalten? Überprüfen Sie die Adresse und versuchen Sie es erneut"
		},
		"resent": {
			"title": "Wir haben Ihnen einen neuen Anmeldelink gesendet",
			"body": "Der Link, den Sie geöffnet haben, ist abgelaufen. Wenn Ihre E-Mail-Adresse zu einer Bewerbung passt, ist ein neuer Anmeldelink zu Ihnen unterwegs. Er öffnet dieselbe Seite.",
			"request_manually": "Nicht erhalten? Fordern Sie einen neuen Link an"
		},
		"request_error": {
			"throttled": "Zu viele Versuche. Bitte warten Sie eine Minute und versuchen Sie es erneut.",
			"invalid_email": "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
			"generic": "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut."
		},
		"unknown_organisation": {
			"title": "Seite nicht gefunden",
			"body": "Überprüfen Sie den von Ihnen aufgerufenen Link oder verwenden Sie den Link aus Ihrer E-Mail."
		},
		"error": {
			"title": "Etwas ist schiefgelaufen",
			"body": "Wir konnten diese Seite nicht laden. Bitte versuchen Sie es gleich noch einmal."
		}
	},
	"organisations": {
		"title": "Ihre Bewerbungen",
		"intro": "Wählen Sie ein Unternehmen aus, um die Bewerbungen zu sehen, die Sie an dieses gesendet haben.",
		"count_one": "{{count}} Bewerbung",
		"count_other": "{{count}} Bewerbungen",
		"empty": {
			"title": "Noch keine Bewerbungen",
			"body": "Sobald Sie sich bei einem Unternehmen bewerben, wird es hier angezeigt."
		},
		"error": "Wir konnten Ihre Unternehmen nicht laden. Bitte versuchen Sie es gleich noch einmal.",
		"log_out": "Abmelden",
		"logging_out": "Wird abgemeldet…"
	},
	"submissions": {
		"title": "Frühere Bewerbungen",
		"back_to_organisations": "Alle Unternehmen",
		"cv_uploaded": "Lebenslauf hochgeladen",
		"empty": {
			"title": "Noch keine Bewerbungen",
			"body": "Bewerbungen, die Sie an {{organisation}} senden, werden hier angezeigt."
		},
		"error": "Wir konnten Ihre Bewerbungen nicht laden. Bitte versuchen Sie es gleich noch einmal.",
		"log_out": "Abmelden",
		"logging_out": "Wird abgemeldet…"
	},
	"profile": {
		"link": {
			"title": "Ihr Profil",
			"cv_added": "Lebenslauf hinzugefügt",
			"cv_missing": "Noch kein Lebenslauf"
		},
		"back": "Zurück zur Bewerbung",
		"context": "{{campaign}} · {{organisation}}",
		"contact_consent": "Sie sind damit einverstanden, zu dieser Stelle kontaktiert zu werden.",
		"cv": {
			"title": "Lebenslauf",
			"upload": {
				"title": "Lebenslauf hochladen",
				"drop_hint": "oder hierher ziehen und ablegen",
				"constraints": "{{types}}, bis zu {{size}} MB",
				"uploading": "{{fileName}} wird hochgeladen…",
				"done": "Lebenslauf hochgeladen",
				"error_type": "Dieser Dateityp wird nicht unterstützt. Erlaubte Typen: {{types}}.",
				"error_size": "Diese Datei ist zu groß. Die maximale Größe beträgt {{size}} MB."
			},
			"remove": {
				"label": "{{fileName}} entfernen",
				"question": "{{fileName}} entfernen?",
				"consequence": "Der Arbeitgeber kann die Datei dann nicht mehr sehen. Dies kann nicht rückgängig gemacht werden.",
				"confirm": "Lebenslauf entfernen",
				"cancel": "Abbrechen",
				"removing": "Wird entfernt…",
				"error": "Der Lebenslauf konnte nicht entfernt werden. Bitte erneut versuchen."
			}
		},
		"work_history": {
			"title": "Berufserfahrung",
			"description": "Erzählen Sie uns von Ihrer relevanten Berufserfahrung: wo Sie gearbeitet haben, was Sie dort gemacht haben und wie lange Sie dort tätig waren. Sie können mehr als eine Stelle angeben, wenn sie relevant sind.",
			"placeholder": "Beschreiben Sie eine frühere Stelle",
			"input_label": "Angaben zur Stelle",
			"save": "Speichern",
			"saving": "Wird gespeichert…",
			"cancel": "Abbrechen",
			"edit": "Bearbeiten",
			"remove": "Entfernen",
			"add_another": "Weitere Stelle hinzufügen",
			"error_empty": "Schreiben Sie etwas, bevor Sie speichern.",
			"error_limit": "Sie können bis zu {{max}} Stellen hinzufügen.",
			"unsaved_changes": "Sie haben ungespeicherte Änderungen an Ihrer Berufserfahrung. Möchten Sie die Seite trotzdem verlassen und die Änderungen verwerfen?",
			"hints": {
				"label": "Angaben zu dieser Stelle",
				"included": "angegeben",
				"missing": "noch nicht angegeben"
			}
		},
		"education": {
			"title": "Ausbildung",
			"description": "Erzählen Sie uns von Ihrer relevanten Ausbildung: was Sie gelernt oder studiert haben, wo und wann. Abschlüsse, Schulen, Kurse und Zertifikate zählen alle. Sie können mehr als einen Eintrag hinzufügen.",
			"placeholder": "Beschreiben Sie einen Abschluss, eine Schule oder einen Kurs",
			"input_label": "Angaben zur Ausbildung",
			"save": "Speichern",
			"saving": "Wird gespeichert…",
			"cancel": "Abbrechen",
			"edit": "Bearbeiten",
			"remove": "Entfernen",
			"add_another": "Weitere Ausbildung hinzufügen",
			"error_empty": "Schreiben Sie etwas, bevor Sie speichern.",
			"error_limit": "Sie können bis zu {{max}} Ausbildungseinträge hinzufügen.",
			"unsaved_changes": "Sie haben ungespeicherte Änderungen an Ihrer Ausbildung. Möchten Sie die Seite trotzdem verlassen und die Änderungen verwerfen?"
		},
		"licenses": {
			"title": "Führerscheine und Zertifikate",
			"description": "Erzählen Sie uns von Ihren Führerscheinen, Berechtigungen und Zertifikaten, zum Beispiel Führerschein, Staplerschein oder Gesundheitszeugnis. Geben Sie an, wann Sie sie erhalten haben und wann sie ablaufen, falls zutreffend. Sie können mehr als einen Eintrag hinzufügen.",
			"placeholder": "Beschreiben Sie einen Führerschein oder ein Zertifikat",
			"input_label": "Angaben zum Nachweis",
			"save": "Speichern",
			"saving": "Wird gespeichert…",
			"cancel": "Abbrechen",
			"edit": "Bearbeiten",
			"remove": "Entfernen",
			"add_another": "Weiteren Nachweis hinzufügen",
			"error_empty": "Schreiben Sie etwas, bevor Sie speichern.",
			"error_limit": "Sie können bis zu {{max}} Nachweise hinzufügen.",
			"unsaved_changes": "Sie haben ungespeicherte Änderungen an Ihren Nachweisen. Möchten Sie die Seite trotzdem verlassen und die Änderungen verwerfen?"
		}
	},
	"submission": {
		"back": "Zurück zu meinen Bewerbungen",
		"back_short": "Zurück",
		"not_found": {
			"title": "Bewerbung nicht gefunden",
			"body": "Diese Bewerbung existiert nicht oder gehört nicht zu Ihren."
		},
		"result": {
			"heading": "Der Bestätigungsbildschirm, den Sie nach der Bewerbung gesehen haben"
		},
		"summary": {
			"title": "Zusammenfassung Ihrer Antworten",
			"submitted_on": "Sie haben dieses Formular abgesendet am",
			"submitted_more_than_once": "Sie haben dieses Formular mehr als einmal ausgefüllt. Wir führen Ihr Profil automatisch zusammen; die untenstehende Bewerbung ist die aktuellste."
		}
	}
}
